import PlayArrow from '@mui/icons-material/PlayArrow';
import { CardActionArea } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';

/*

!!!!!!!!!!NOT USING THIS FILE ANYMORE!!!!!!!!!
       USING 'GalleryCard.tsx' INSTEAD

*/

const CardItem = styled(Card)(({ theme }) => ({
  borderRadius: '7px',
  width: '109px',
  minWidth: '108px',
  height: '139px',
  backgroundColor: 'transparent',
}));

const TextCardContentItem = styled(CardContent)(({ theme }) => ({
  position: 'absolute',
  padding: 'unset',
  top: '115px',
  left: '84px',
}));
const ImgCardContentItem = styled(CardContent)(({ theme }) => ({
  position: 'absolute',
  padding: 'unset',
  top: '115px',
  left: '62px',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '11px',
  opacity: '0.757',
}));

interface galleryCardsProps {
  views: number;
  image: string;
}

const GalleryCards: React.FC<galleryCardsProps> = ({ views, image }) => {
  const GalleryCardImg1 = require('assets/Profile/gallery1.png');
  return (
    <CardItem>
      <CardActionArea>
        <CardMedia
          component="img"
          src={image || GalleryCardImg1}
          alt="GalleryItem"
          sx={{ objectFit: 'cover', height: '200px' }}
        />
        <ImgCardContentItem>
          <PlayArrow
            style={{
              opacity: '0.757',
              color: '#ffffff',
              padding: 'unset',
              fontSize: '16px',
            }}
          />
        </ImgCardContentItem>
        <TextCardContentItem>
          <TitleText>{views}</TitleText>
        </TextCardContentItem>
      </CardActionArea>
    </CardItem>
  );
};

export default GalleryCards;
